
<section class="profile-intro-container">
  <div class="sm:pt-24">
    <Card class="profile-intro-card mx-auto max-w-488 box-shadow-none p-0 sm:box-shadow-sm sm:p-24 sm:mt-24">
      <img
        src="//images.ctfassets.net/wmwzystk5o45/2ssmjyxawilr37DN1hriUA/fdbdd1efc168a4fae85724d2cf511e88/profile-intro-mobile-top.webp"
        class="w-full h-auto sm:hidden"
        alt=""
      />
      <div class="p-16 sm:p-0">
        <h1 class="text-h2">{{ title }}</h1>
        <div v-for="(step, index) in steps" :key="index" class="mt-24">
          <div class="flex gap-16">
            <div>
              <div class="flex items-center gap-4">
                <TickCircleIcon v-if="step.completed" color="#229150" :width="16" :height="16" />
                <h2 class="text-strong-body">{{ step.title }}</h2>
              </div>
              <p class="text-body ml-20">{{ step.body }}</p>
            </div>
            <component :is="step.icon" :width="56" :height="56" class="min-w-56" />
          </div>
          <hr v-if="index < steps.length - 1" class="my-16 border-grey-divider-contrast sm:my-24" />
        </div>
      </div>
      <img
        src="//images.ctfassets.net/wmwzystk5o45/CeE9BHSiTx19ZNLcoP9cH/025cda561637239e0d336b27566c623f/profile-intro-mobile-bottom.webp"
        class="w-full h-auto sm:hidden"
        alt=""
      />
      <StickyButton class="sm:mt-24" value="Build my profile" size="medium" to="/care-type" />
    </Card>
  </div>
</section>
